import { __ } from '@wordpress/i18n';
import { PanelBody, SelectControl, __experimentalUnitControl as UnitControl, __experimentalNumberControl as NumberControl, ToggleControl, PanelRow, __experimentalAlignmentMatrixControl as AlignmentMatrixControl, RangeControl } from "@wordpress/components";
import { animationFreeOptions, animationOptions, arrowStyles, contentPosition, emUnit, indicatorOption, indicatorOptions, perUnit, sliderOption, titleTag, caroDirectionOpt, carouselStyOpt, effectOpt } from '../../../../utils/options';

import { BtnGroup, Label } from '../../../../../../bpl-tools/Components';
import { pxUnit, vhUnit } from '../../../../../../bpl-tools/utils/options';
import { BDevice } from '../../../../../../bpl-tools/Components/Deprecated';
import icons from '../../../../../../bpl-tools/Components/IconControl/icons';

import { BControlPro, SelectControlPro } from '../../../../../../bpl-tools/ProControls';
import { checkDirection } from '../../../../utils/functions';

import Controls from './Carousel/Controls';
import ButtonGroupController from '../ButtonGroupController';
import Notice from '../../Notice';

const DefaultGeneral = ({ attributes, setAttributes, premiumProps, updateObject, gapDevice, setGapDevice, device, setDevice }) => {

    const { layoutType, title, titleFCaption, slideInnerGap, options, height, sliderHeight, slideInnerGapDevice, animation, arrowStyle, isMouseWheel, position, isArrowFollowSlide, isMouseDrag, isLazyLoad, direction, arrow, indicator, carousel, columns, rowGap, columnGap, sourceType } = attributes;
    const { effect, carouselStyle, reverseDirection, caroDirection } = carousel;



    return <>

        <PanelBody className='bPlPanelBody' title={__('Title', 'slider')} initialOpen={false}>

            <BControlPro label={__('Tag', 'Slider')} options={titleTag} labelPosition='left' value={title?.tag || 'h5'} onChange={val => updateObject('title', 'tag', val)} Component={SelectControl} {...premiumProps} />

            <ToggleControl className='mt10' label={__('Import Title From Media Caption', 'slider')} checked={titleFCaption} onChange={(val) => setAttributes({ titleFCaption: val })} />
        </PanelBody>

        {
            layoutType === "carousel" && <PanelBody className='bPlPanelBody' title={__('Controls', 'slider')} initialOpen={false}>

                <SelectControlPro label={__('Carousel Style', "slider")} value={carouselStyle} options={carouselStyOpt} onChange={val => updateObject("carousel", "carouselStyle", val)} proValues={['ticker', 'grid', '3dcarousel']} {...premiumProps} />

                {carouselStyle !== "ticker" && <> {
                    (carouselStyle !== "grid" && carouselStyle !== "3dcarousel") && <BControlPro label={__('Effect', "slider")} value={effect} options={effectOpt} onChange={val => updateObject("carousel", "effect", val)} Component={SelectControl} {...premiumProps} />}

                    <Controls attributes={attributes} updateObject={updateObject} premiumProps={{ ...premiumProps }} />
                </>}

                {carouselStyle === "ticker" && <ToggleControl className='mt10' label={__("Reverse Direction", "slider")} checked={reverseDirection} onChange={val => updateObject("carousel", "reverseDirection", val)} />}

                {(carouselStyle === "standard" || carouselStyle === "ticker") && <SelectControl className='mt10' label={__('Direction', "slider")} value={caroDirection} options={caroDirectionOpt} onChange={val => updateObject("carousel", "caroDirection", val)} />}

                {carouselStyle !== "ticker" && <>
                    <BControlPro className='mt10' label={__('Show Arrow/Navigation', 'slider')} checked={arrow.visibility} onChange={(value) => { updateObject('arrow', 'visibility', value) }} Component={ToggleControl} {...premiumProps} />

                    <BControlPro className='mt10' label={__('Show Indicators/Pagination', 'slider')} checked={indicator.visibility} onChange={(value) => updateObject('indicator', 'visibility', value)} Component={ToggleControl} {...premiumProps} />
                </>}
            </PanelBody>
        }

        <PanelBody className='' title={__('Layout Settings', 'slider')} initialOpen={false}>

            {(sourceType === "image" && layoutType === "image") && <>

                <PanelRow className='mt20'>
                    <Label mt='0'>{__('Gap:', 'slider')}</Label>
                    <BControlPro device={gapDevice} onChange={val => setGapDevice(val)} Component={BDevice} {...premiumProps} />
                </PanelRow>

                <BControlPro className='mb20' label={__('Left/Right Inner Gap', 'slider')} labelPosition='left' value={slideInnerGapDevice[gapDevice] || slideInnerGap} onChange={val => { setAttributes({ slideInnerGapDevice: { ...slideInnerGapDevice, [gapDevice]: val } }) }} units={[pxUnit(400), vhUnit(30)]} isResetValueOnUnitChange={true} beforeIcon='grid-view' Component={UnitControl} {...premiumProps} />
            </>}

            {(layoutType !== "carousel" && layoutType !== "grid" && layoutType !== "thumbnails") && <>
                <BControlPro className='mt20' label={__('Slide Direction', 'slider')} labelPosition='left' value={direction} options={sliderOption} onChange={(val) => { setAttributes({ direction: val }) }} Component={SelectControl} {...premiumProps} />
            </>}

            {
                (layoutType === "grid" || layoutType === "carousel" || layoutType === "thumbnails") && <>
                    <PanelRow className='mt10'>
                        <Label mt='0'>{__('Columns:', 'slider')}</Label>
                        <BDevice device={device} onChange={val => setDevice(val)} />
                    </PanelRow>

                    <RangeControl value={columns[device]} onChange={val => { setAttributes({ columns: { ...columns, [device]: val } }) }} min={1} max={6} step={1} beforeIcon='grid-view' />
                    {
                        sourceType === "thumbnails" && <Notice />
                    }

                    {/* column Gap  */}
                    <UnitControl className='mt20' label={__('Column Gap:', 'slider')} labelPosition='left' value={columnGap} onChange={val => setAttributes({ columnGap: val })} units={[pxUnit(30), perUnit(3), emUnit(2)]} isResetValueOnUnitChange={true} />
                </>
            }

            {/* row Gap  */}
            {layoutType === 'grid' && <UnitControl className='mt20' label={__('Row Gap:', 'slider')} labelPosition='left' value={rowGap} onChange={val => setAttributes({ rowGap: val })} units={[pxUnit(40), perUnit(3), emUnit(2.5)]} isResetValueOnUnitChange={true} />}


            {/* Height define option  */}
            <PanelRow className='mt20'>
                <Label mt='0'>{__('Height:', 'slider')}</Label>
                <BControlPro label={__('Slider Height')} device={device} onChange={val => setDevice(val)} Component={BDevice} {...premiumProps} />
            </PanelRow>

            <UnitControl className='mb20' label={`${layoutType === 'grid' ? 'Item' : 'Slider'} Height`} labelPosition='left' value={sliderHeight[device] || height} onChange={val => { setAttributes({ sliderHeight: { ...sliderHeight, [device]: val } }) }} units={[pxUnit(400), vhUnit(30)]} isResetValueOnUnitChange={true} beforeIcon='grid-view' />

            {(sourceType !== "video" && (layoutType !== "carousel" && layoutType !== "grid" && layoutType !== "thumbnails")) && <PanelRow>
                {premiumProps?.isPremium ?
                    <><Label>{__('Content Position:', 'slider')}</Label>
                        <AlignmentMatrixControl value={position?.top || position} onChange={val => setAttributes({ position: val })} />
                    </> :
                    <SelectControl label={__('Content Position:', 'slider')} labelPosition='left' value={position} options={contentPosition} onChange={(val) => { setAttributes({ position: val }) }} />
                }
            </PanelRow>}

            {(arrow?.visibility && layoutType !== "grid") &&
                <BControlPro label={__('Arrow Style:', 'slider')} value={arrowStyle} onChange={(arrowStyle) => setAttributes({ arrowStyle })} {...premiumProps} Component={ButtonGroupController} options={arrowStyles} />}
        </PanelBody>

        {(layoutType !== "carousel" && layoutType !== "grid" && layoutType !== "thumbnails") && <>
            <PanelBody className='' title={__('Slider Options', 'slider')} initialOpen={false}>

                {premiumProps?.isPremium ?
                    <SelectControl label={__('Animation/Effect:', 'slider')} labelPosition='side' value={animation} onChange={(val) => setAttributes({ animation: val })} options={animationOptions} />
                    :
                    <>
                        <PanelRow>
                            <Label className='mb0'>{__('Animation/Effect:', 'slider')}</Label>
                            <BtnGroup value={animation} onChange={val => setAttributes({ animation: val })} options={animationFreeOptions} />
                        </PanelRow>
                    </>
                }

                <ToggleControl className='mt20' label={__('Autoplay', 'slider')} checked={options.ride} onChange={(value) => updateObject('options', 'ride', value)} />

                {options.ride && <>
                    <NumberControl className='mb10' label={__('Interval(ms)', 'slider')} labelPosition='left' value={options.interval} onChange={(value) => updateObject('options', 'interval', parseInt(value))} min={1000} max={10000} />

                    <ToggleControl className='mt10' label={__('Pause on Mouse over', 'slider')} checked={options.pause} onChange={(value) => updateObject('options', 'pause', value)} />
                </>}

                <ToggleControl className='mt20' label={__('Show Arrow/Navigation', 'slider')} checked={arrow.visibility} onChange={(value) => { updateObject('arrow', 'visibility', value) }} />

                {
                    (layoutType !== "carousel" && layoutType !== "grid" && layoutType !== "thumbnails") && <ToggleControl className='mt10' label={__('Show Indicators/Pagination', 'slider')} checked={indicator.visibility} onChange={(value) => updateObject('indicator', 'visibility', value)} />
                }

                <BControlPro className='mt20' label={__('Slide On MouseWheel', 'slider')} checked={isMouseWheel} onChange={(val) => setAttributes({ isMouseWheel: val })} Component={ToggleControl} {...premiumProps} />
                {
                    sourceType !== "video" && <>
                        <BControlPro className='mt10 marginLeft' label={__('Arrow Follow Mouse', 'slider')} checked={isArrowFollowSlide} onChange={(val) => setAttributes({ isArrowFollowSlide: val })} Component={ToggleControl} {...premiumProps} />
                        <small className='warning'>{icons.warning}Only work frontEnd and button will not work</small>
                    </>
                }

                <BControlPro className='mt10 marginLeft' label={__('Slide on Mouse Drag', 'slider')} checked={isMouseDrag} onChange={(val) => setAttributes({ isMouseDrag: val })} Component={ToggleControl} {...premiumProps} />
                <small className='warning'>Arrow Follow Mouse enable slide on mouse drag not working</small>

                <BControlPro className='mt20' label={__('Lazy Load Enable', 'slider')} checked={isLazyLoad} onChange={(val) => setAttributes({ isLazyLoad: val })} Component={ToggleControl} {...premiumProps} />
            </PanelBody>
        </>}

        {((layoutType !== "carousel" && layoutType !== "grid" && layoutType !== "thumbnails") && indicator.visibility) && <PanelBody className='bPlPanelBody' title={__('Indicators', 'slider')} initialOpen={false}>
            <BControlPro className='mt10' label={__('Type', 'slider')} value={indicator?.type} labelPosition='left' onChange={(val) => setAttributes({
                indicator: {
                    ...indicator,
                    type: val,
                    width: 'image' === val ? '80px' : '30px',
                    height: 'image' === val ? '80px' : '3px',
                    radius: 'image' === val ? '50%' : '0px',
                    moveFromEdge: 'image' === val ? '50%' : '-15px',
                }
            })} options={indicatorOption} Component={SelectControl} {...premiumProps} />

            {premiumProps?.isPremium && <PanelRow className='mt20 mb10'>
                <Label className='mb0'>{__('Position:', 'slider')}</Label>
                <AlignmentMatrixControl value={indicator.position}
                    onChange={val => {
                        setAttributes({
                            indicator: { ...indicator, position: val, ...checkDirection(val) },
                        })
                    }}
                />
            </PanelRow>}

            <BControlPro label={__('Direction', 'slider')} labelPosition='side' value={indicator.direction} onChange={(val) => { updateObject('indicator', 'direction', val) }} options={indicatorOptions} Component={SelectControl} {...premiumProps} />

            {
                indicator.position !== 'center center' && <>
                    <BControlPro className='mb20 mt20 marginLeft' label={__('Move From Edge', 'slider')} labelPosition='left' value={indicator.moveFromEdge} onChange={(val) => updateObject('indicator', 'moveFromEdge', val)} units={[pxUnit(40), perUnit(50)]} isResetValueOnUnitChange={true} Component={UnitControl} {...premiumProps} />
                    <small className='warning'>{__('Use a negative or positive value to move in or out.', 'slider')}</small>
                </>
            }
        </PanelBody>}
    </>
}
export default DefaultGeneral;